export default "__VITE_ASSET__4STC86OR__"